// extracted by mini-css-extract-plugin
export var bodyRow = "_db-d";
export var cardColumns = "_db-e";
export var ellipsesOverflow = "_db-2";
export var flatBottomCorners = "_db-3";
export var flatTopCorners = "_db-4";
export var headerActionsDropdown = "_db-f";
export var headerBottomRow = "_db-c";
export var headerTopRow = "_db-b";
export var orderDetailsWrapper = "_db-0";
export var orderInfoContainer = "_db-1";
export var productDetails = "_db-9";
export var productImage = "_db-5";
export var responsiveTable = "_db-8";
export var shipmentContainer = "_db-a";
export var tableBottomLeft = "_db-6";
export var tableBottomRight = "_db-7";
export var trackingLink = "_db-g";